import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useFocusTrap } from '../a11y/useFocusTrap';
import { Icon } from '../icon/Icon';
import styles from './shell.module.css';
/**
 * Help & support (doc 04 §1). A real header affordance with an honest body: the
 * help center is not live in this build, so it says exactly that rather than
 * linking to a page that does not exist.
 */
export function HelpMenu() {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        function onDown(e) {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        }
        function onKey(e) {
            if (e.key === 'Escape')
                setOpen(false);
        }
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    // The panel holds no controls of its own, so the trap focuses the panel
    // itself — which is what makes it readable at all by a screen reader driven
    // from the keyboard — and returns focus to the trigger on close.
    const menuRef = useFocusTrap(open, { onEscape: () => setOpen(false) });
    return (_jsxs("div", { className: styles.help, ref: ref, children: [_jsx("button", { type: "button", className: styles.helpTrigger, "aria-label": "Help & support", "aria-expanded": open, onClick: () => setOpen((v) => !v), children: _jsx(Icon, { name: "handbook", size: 18 }) }), open ? (_jsxs("div", { ref: menuRef, className: styles.helpMenu, role: "dialog", "aria-label": "Help & support", children: [_jsx("span", { className: styles.helpTitle, children: "Help & support" }), _jsx("p", { className: styles.helpBody, children: "The help center isn\u2019t live in this build yet. If you\u2019re stuck, reach out to whoever manages your organization." })] })) : null] }));
}
//# sourceMappingURL=HelpMenu.js.map